export const CYCLE_TIME_REPORT_KEY = 'jsw.report.cycle-time';
export const CI_CD_GET_STARTED_LINK =
	'https://www.atlassian.com/software/jira/guides/developers/ci-cd#get-started';
